const state = {
  bookingIdentifier: null,
  luggageOptionsPerTrip: null
}

const getters = {
  bookingIdentifier: (state) => state.bookingIdentifier,
  luggageOptionsPerTrip: (state) => state.luggageOptionsPerTrip
}

const actions = {
  setBookingIdentifier ({ commit }, bookingIdentifier) { commit('setBookingIdentifier', bookingIdentifier) },
  setLuggageOptionsPerTrip ({ commit }, luggageOptionsPerTrip) { commit('setLuggageOptionsPerTrip', luggageOptionsPerTrip) },
  resetStates ({ commit }) {
    commit('setBookingIdentifier', null)
    commit('setLuggageOptionsPerTrip', null)
  }
}

const mutations = {
  setBookingIdentifier: (state, bookingIdentifier) => { state.bookingIdentifier = bookingIdentifier },
  setLuggageOptionsPerTrip: (state, luggageOptionsPerTrip) => { state.luggageOptionsPerTrip = luggageOptionsPerTrip }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
